export const SITE = {
  name: 'Simone Carani',
  url: 'https://www.symhos.dev',
  description:
    'IT Manager, developer and consultant. I provide the tools to ask what you want to your data.',
  author: 'Simone Carani',
  twitterHandle: '@simonecarani',
  locale: 'en_US',
};

export function buildPersonSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: SITE.name,
    url: SITE.url,
    jobTitle: 'IT Manager',
    description: SITE.description,
    sameAs: [
      'https://github.com/carsim',
      'https://www.linkedin.com/in/simonecarani',
    ],
  };
}

export function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE.name,
    url: SITE.url,
    description: SITE.description,
    author: { '@type': 'Person', name: SITE.name },
  };
}

export function buildArticleSchema({ title, description, date, url, slug }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    datePublished: date,
    url: url || `${SITE.url}/articles/${slug}`,
    author: { '@type': 'Person', name: SITE.name },
    publisher: { '@type': 'Person', name: SITE.name },
  };
}

export function buildProjectSchema({ title, description, url, slug }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'CreativeWork',
    name: title,
    description,
    url: url || `${SITE.url}/projects/${slug}`,
    author: { '@type': 'Person', name: SITE.name },
  };
}
